import { api } from './api'

export interface NotificationDto {
  id: number
  title: string
  body: string
  /** "info" | "success" | "warning" | "danger" — semantic colour for the UI. */
  type: string
  /** Free-form grouping key (e.g. "attendance" | "leave" | "sale"). */
  category: string | null
  /** Optional path to navigate to when the notification is clicked. */
  link: string | null
  /** JSON blob attached by the publisher; opaque to the UI. */
  payloadJson: string | null
  /** ISO-8601 UTC. */
  createdAt: string
  /** ISO-8601 UTC or null when still unread. */
  readAt: string | null
  /** Server-computed convenience flag. */
  isRead: boolean
}

export interface NotificationListResponse {
  items: NotificationDto[]
  total: number
  unreadCount: number
}

export interface NotificationListParams {
  skip?: number
  take?: number
  unreadOnly?: boolean
}

/**
 * Notifications REST API client. The bell + Activity Feed both consume this.
 *
 * Convention: every call is scoped to the current user server-side (controller
 * filters by `User.FindFirstValue(ClaimTypes.NameIdentifier)`), so the
 * frontend never has to pass a user id.
 */
export const notificationsApi = {
  list: (params: NotificationListParams = {}) =>
    api
      .get<NotificationListResponse>('/api/notifications', { params })
      .then((r) => r.data),

  unreadCount: () =>
    api.get<{ count: number }>('/api/notifications/unread-count').then((r) => r.data.count),

  markRead: (id: number) => api.post(`/api/notifications/${id}/read`).then(() => undefined),

  markAllRead: () =>
    api
      .post<{ marked: number }>('/api/notifications/mark-all-read')
      .then((r) => r.data.marked),

  remove: (id: number) => api.delete(`/api/notifications/${id}`).then(() => undefined),
}
